import type { MimecastGenericInputCreateRequest, MimecastInputCreateRequest } from './types';

import type { FormDataType } from '../common/utils/types';

export const toMimecastInputCreateRequest = ({
  mimecastName,
  clientId,
  clientSecret,
  contentTypes,
  mimecastThrottleEnabled,
  pollingInterval,
}: FormDataType): MimecastInputCreateRequest => ({
  name: mimecastName?.value,
  client_id: clientId?.value,
  client_secret: clientSecret?.value,
  content_type: contentTypes?.value?.split(','),
  enable_throttling: !!mimecastThrottleEnabled?.value,
  polling_interval: pollingInterval?.value,
  polling_time_unit: 'MINUTES',
});

export const toGenericInputCreateRequest = ({
  mimecastName,
  clientId,
  clientSecret,
  mimecastThrottleEnabled,
  pollingInterval,
  contentTypes,
}: FormDataType): MimecastGenericInputCreateRequest => ({
  type: 'org.graylog.enterprise.integrations.mimecastv2.MimecastV2Input',
  title: mimecastName.value,
  global: false,
  configuration: {
    client_id: clientId?.value,
    client_secret: clientSecret?.value,
    content_type: contentTypes.value.split(','),
    throttling_allowed: !!mimecastThrottleEnabled?.value,
    polling_interval: pollingInterval.value,
    polling_time_unit: 'MINUTES',
  },
});
